import { render, staticRenderFns } from "./CartPageCrossSellContent.vue?vue&type=template&id=2765b2db&scoped=true"
import script from "./CartPageCrossSellContent.vue?vue&type=script&lang=js"
export * from "./CartPageCrossSellContent.vue?vue&type=script&lang=js"
import style0 from "./CartPageCrossSellContent.vue?vue&type=style&index=0&id=2765b2db&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2765b2db",
  null
  
)

export default component.exports